import clsx from 'shared/libs/clsx'

import { Image } from 'shared/ui/Image'

interface LogoMainProps {
  showOnlyLogo?: boolean
  className?: string
}
export function LogoMain({ showOnlyLogo, className }: LogoMainProps) {
  return (
    <div
      className={clsx(
        'flex items-center gap-[12px] py-[12px] px-[16px] border-b border-light_gray_3 w-full justify-center',
        className,
      )}
    >
      <Image src="/logos/logo.svg" />
      {!showOnlyLogo && (
        <Image
          className="mt-1"
          src="/logos/logo-name.svg"
          height={28}
        />
      )}
    </div>
  )
}
